const searchGym = () => {};

export default searchGym;
